/*
  Helps to fix headers, footers on the screen by checking trigger visibility.

  The layout:

  [trigger]
  [container]
    [header]
  [/container]

  const Page = () => {
    const triggerRef = useRef<HTMLDivElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const headerRef = useRef<HTMLDivElement>(null)

    const isFixed = useFixed({
      triggerRef,
      containerRef,
      nodeRef,
    })

    return (
      <Fragment>
        <div ref={triggerRef} />
        <div ref={containerRef}>
          <div ref={headerRef} className={isFixed ? s.fixed : null} />
        </div>
      </Fragment>
    )
  }
 */

import { useRef } from 'react'
import useVisibility from './useVisibility'


export type UseFixedProps = {
  // node for default placement
  triggerRef: React.RefObject<any>
  // container of the fixed node, will preserve height
  containerRef: React.RefObject<any>
  // the fixed node it self
  nodeRef: React.RefObject<any>
}

const useFixed = (props: UseFixedProps): boolean => {
  const { triggerRef, containerRef, nodeRef } = props

  const [ isVisible ] = useVisibility(triggerRef)
  const prevVisibleRef = useRef(isVisible)

  // We can't use useEffect, because minHeight should be set before rendering with className
  // useEffect is working after rendering
  if (prevVisibleRef.current !== isVisible) {
    prevVisibleRef.current = isVisible

    if (nodeRef.current && containerRef.current) {
      containerRef.current.style.minHeight = isVisible ? null : `${nodeRef.current.offsetHeight}px`
    }
  }

  return !isVisible
}


export default useFixed
